import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AlertService, IAlertType, OffersStoreService } from '../../../../_shared/services';

import moment from "moment";
import { ClrCommonFormsModule, ClrIconModule } from "@clr/angular";
import { JsonPipe, NgIf } from "@angular/common";
import {ClarityIcons, exclamationCircleIcon, floppyIcon} from "@cds/core/icon";

import { environment as env } from "../../../../../environments/environment";

@Component({
  selector: 'app-offer-edit-position',
  standalone: true,
  imports: [
    ClrIconModule,
    NgIf,
    ClrCommonFormsModule,
    ReactiveFormsModule,
    JsonPipe
  ],
  templateUrl: './offer-edit-position.component.html',
  styleUrl: './offer-edit-position.component.sass'
})
export class OfferEditPositionComponent implements OnInit {
  public editOffersForm!: FormGroup;
  positions: any; // PositionsList[] = [];
  loading = false;

  @Input() projectNumber: string = '';
  @Input() offerNumber: number = 0;
  @Input() editPosition: number = 0;
  @Input() editPart: number = 0;
  @Output() updatedPosition = new EventEmitter();

  devMode: boolean;

  constructor(
    private offss: OffersStoreService,
    private fb: FormBuilder,
    private alertDispatcher: AlertService,
  ) {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(floppyIcon, exclamationCircleIcon)
  }

  ngOnInit() {
    this.loadOffersPosition(this.projectNumber, this.offerNumber, this.editPosition, this.editPart);
  }

  initForm() {
    if (this.editOffersForm) {
      return;
    }

    this.editOffersForm = this.fb.group({
      project_id: [this.projectNumber],
      offer_id: [this.offerNumber],
      position: [this.editPosition],
      part: [this.editPart],
      for_pdf: [this.positions[0].for_pdf],
      name: [this.positions[0].name],
      technical_drawing: [this.positions[0].technical_drawing],
      material: [this.positions[0].material],
      weight: [this.positions[0].weight],
      description: [this.positions[0].description],
      remarks:  [this.positions[0].remarks],
      side_agreements: [this.positions[0].side_agreements],
      selling_price:  [this.positions[0].selling_price],
      delivery_date:  [moment(this.positions[0].delivery_date).format("DD.MM.yyyy")],
      status:  [this.positions[0].status],
      number_of_pieces: [this.positions[0].number_of_pieces],
      budget: [this.positions[0].budget],
      purchasing_price: [this.positions[0].purchasing_price],
      technology: [this.positions[0].technology],
      serial_nr: [this.positions[0].serial_nr],
      controlling_nr: [this.positions[0].controlling_nr],
      heat_nr: [this.positions[0].heat_nr],
      taric: [this.positions[0].taric],
      comment_phm: [this.positions[0].comment_phm],
      specification: [this.positions[0].specification],
    });
  }

  loadOffersPosition(prid: string, offid: number, posid: number, partid: number) {
    const posID = posid.toString();
    this.offss.getOffersPositions(prid, offid, posID, partid).subscribe(data => {
      if (!data) {
        return;
      }
      this.positions = data.object;
      console.table(data);
      console.table(this.positions);
      // this.positions = Object.values(this.positions);
      this.initForm();
    });
  }

  updateOffersPosition() {
    if (this.editOffersForm.valid) {
      const formValue = this.editOffersForm.value;
    this.offss.updateOffersPosition(formValue).subscribe({
      next: () => {
        this.alertDispatcher.show({
          message: 'Position erfolgreich aktualisiert',
          clrAlertType: IAlertType.SUCCESS
        }, 5000);
        this.updatedPosition.emit(true);

      },
      error: (error) => {
        this.alertDispatcher.show({
          message: 'Fehler beim Aktualisieren der Position: ' + error,
          clrAlertType: IAlertType.DANGER
        }, 5000);
      }
    });
    }
  }

  cancelEdit() {
    this.updatedPosition.emit(true);
  }
}
